import api from '@/services/Api';
import Diagnose from '@/types/Diagnose';
import { successSwal, warningSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { DiagnosenLoaders, DiagnosenState, RootState } from '@/store/types';

export type DiagnosenFilter = {
    gueltig: string;
};

export type LoadDiagnosenPayload = {
    filter: DiagnosenFilter;
};

export type ExportDiagnosenPayload = {
    filter: DiagnosenFilter;
};

export type UpdateDiagnosePayload = {
    diagnose: Diagnose;
    filter: DiagnosenFilter;
};

export type DeleteDiagnosePayload = {
    diagnose: Diagnose;
    filter: DiagnosenFilter;
};

type Context = ActionContext<DiagnosenState, RootState>;

export const diagnosen: Module<DiagnosenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            diagnosen: false,
            export: false,
        },
        diagnosen: [],
    },
    actions: {
        loadDiagnosen({ commit, rootState }: Context, payload?: LoadDiagnosenPayload): void {
            commit('setLoadersDiagnosen', true);
            commit('setDiagnosen', []);

            api.post('verwaltung/diagnosen/load', payload)
                .then((response) => {
                    commit('setDiagnosen', response.data.body);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDiagnosen', false));
        },
        updateDiagnose({ commit, dispatch }: Context, { diagnose, filter }: UpdateDiagnosePayload): Promise<void> {
            commit('setLoadersSave', true);

            return api.post('verwaltung/diagnosen/speichern', diagnose)
                .then(() => {
                    successSwal('Diagnose', 'gespeichert');
                    dispatch('loadDiagnosen', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => {
                    commit('setLoadersSave', false);
                });
        },
        deleteDiagnose({ commit, dispatch }: Context, { diagnose, filter }: DeleteDiagnosePayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/diagnosen/loeschen', diagnose)
                .then(() => {
                        successSwal('Diagnose', 'gelöscht');
                        dispatch('loadDiagnosen', { filter });
                        commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setDiagnosen(state: DiagnosenState, payload: Partial<Diagnose>[]): void {
            state.diagnosen = payload.map((data) => new Diagnose(data));
        },
        setLoaders(state: DiagnosenState, loaders: DiagnosenLoaders): void {
            state.loaders = {
                ...state.loaders,
                ...loaders,
            };
        },
        setDialogsDetail(state: DiagnosenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: DiagnosenState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: DiagnosenState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersDiagnosen(state: DiagnosenState, visible: boolean): void {
            state.loaders.diagnosen = visible;
        },
    },
};
